import React from 'react';
import { Card, Tabs } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const { TabPane } = Tabs;

function DeletedReport() {
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname.split('/')[2];
  const currentTab = currentPath || 'deleted-campaign';

  const tabKeyMap = {
    'deleted-campaign': '1',
    'deleted-offender': '2',

  };

  const keyTabMap = {
    '1': 'deleted-campaign',
    '2': 'deleted-offender',

  };


  React.useEffect(() => {
    if (location.pathname === '/deleted-report') {
      navigate('/deleted-report/deleted-campaign', { replace: true });
    }
  }, [location.pathname, navigate]);

  const handleTabChange = (key) => {
    navigate(`/deleted-report/${keyTabMap[key]}`);
  };

  const activeKey = tabKeyMap[currentTab];

  return (
    <div className="lms-body">
      <h2 style={{ marginBottom: "20px" }}>
        Deleted Report
      </h2>
      <Card>
        <Tabs activeKey={activeKey} onChange={handleTabChange}>
          <TabPane tab=" Campaign Reports" key="1" />
          <TabPane tab=" Offender Reports" key="2" />

        </Tabs>

        <Outlet />
      </Card>
    </div>
  );
}

export default DeletedReport;
